export default "__VITE_ASSET__N8UHy3BV__"